module.exports = __webpack_public_path__ + "img/portugal-eye-and-ear-diseases-female.20653983.png";